import {
    FetchState,
    TransactionEditSearchResult,
    TransactionEditPut,
    TransactionEditSearch
} from "@/shared/types";
import * as BankService from "@/shared/api/bankService";
import {
    TransactionEditState
} from "@/admin/types";

import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: TransactionEditState = {
    fetchState: FetchState.Uninitialized,
    searchResult: null
};

const emptySearchResult: TransactionEditSearchResult = {
    firstName: null,
    lastName: null,
    custodianName: null,
    employerId: 0,
    employerName: null,
    transactions: []
};

export const useTransactionEditStore = defineStore("transactionEdit", {
    state: (): TransactionEditState => (_.cloneDeep(initialState)),
    getters: {
        getSearchResults: state => state.searchResult
    },
    actions: {
        setSearchResult (searchResult: TransactionEditSearchResult) {
            if (searchResult) {
                this.searchResult = searchResult;
                this.fetchState = FetchState.Loaded;
            } else {
                this.fetchState = FetchState.Loading;
                this.searchResult = null;
            }
        },
        updateDetail (update: TransactionEditPut) {
            const updatedTransactions = [ ...this.searchResult.transactions ];
            updatedTransactions.forEach(element => {
                if (element.id === update.transactionId) {
                    element.transactionType = update.transactionType;
                    element.effectiveYear = update.effectiveYear;
                    element.isArchived = update.isArchived;
                    element.isAmountInverted = update.isAmountInverted;
                }
            });
            this.searchResult.transactions = updatedTransactions;
        },
        loadSearchResults (args: TransactionEditSearch) {
            this.setSearchResult(null);

            return BankService.listTransactionsForEdit(args)
                .then(v => {
                    this.setSearchResult(v.data);
                })
                .catch(err => {
                    if (err && err.response && err.response.status === 404) {
                        this.setSearchResult(emptySearchResult);
                        return;
                    }
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        editTransaction (putArgs: TransactionEditPut) {
            return BankService.putTransactionEdit(putArgs)
                .then(v => {
                    this.updateDetail(putArgs);
                }).catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        }
    }
});
